import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import * as css from "./BulkMarketReports.module.css";
import cmaAppStoreScreenshot from "../../shared/images/cmaAppStoreScreenshot.png";

const BulkReportsNoPlatformModal = ({ closeNoPlatformModal }) => (
  <Modal
    show
    onHide={() => closeNoPlatformModal(true)}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[620px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header closeButton />
    <Modal.Body className={css.modalBody}>
      <img className={css.modalImage} src={cmaAppStoreScreenshot} alt="CMA Screenshot" />
      <div className={css.modalText}>
        <h4>Upgrade to the full Brivity Platform to get Market Reports</h4>
        <hr className="brivity-hr" />
        <div className={css.modalInnerText}>
          <p>
            Market Reports are one of the best ways to nurture seller leads and your sphere by showing them
            what&quot;s going on in the real estate market in their neighborhood.
          </p>
          <p>Market Reports are included with Brivity CMA, which is part of the full Brivity Platform.</p>
          <p>
            <strong>
              Contact us at (866) 295-3322 or sales@brivity.com to upgrade to the Brivity Platform today!
            </strong>
          </p>
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer className="tw-flex tw-justify-center">
      <Button size="medium" onClick={() => closeNoPlatformModal()}>
        Get a Demo
      </Button>
    </Modal.Footer>
  </Modal>
);

BulkReportsNoPlatformModal.propTypes = {
  closeNoPlatformModal: PropTypes.func.isRequired,
};

export default BulkReportsNoPlatformModal;
